import { ValueOf } from "../../../constants";
export const BANK_ID_IFRAME_ID = "bankid-iframe";

export const BANK_ID = {
    ERROR: {
        PARAM: "error",
        PARAM_DESC: "error_description",
        ID: "bankid-error",
    },
    CODE: {
        PARAM: "code",
        ID: "bankid-code",
    },
    NOT_FOUND: {
        ID: "bankid-not-found",
    },
} as const;

export const BANK_ID_TYPES = {
    ALL: "ALL",
    BANK_ID: "BANK_ID",
    OCMC_BANK_ID: "OCMC_BANK_ID",
    CANDOUR: "CANDOUR",
} as const;

export type BankIdTypes = ValueOf<typeof BANK_ID_TYPES>;
